import { Grid, Stack, Switch, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import Conditions from "../../../../../shared/reporting/components/viewer/common/conditions/Conditions";
import PartContainer from "../../../../../shared/reporting/components/viewer/common/PartContainer.tsx";
import { MeasureDrillDownInfo, MetricDrillDownInfo } from "../../../../api/biApi.types";
import { DrillDownState } from "../../../../hooks/useDrillDown";
import { selectDimensions } from "../../../../store/selectors/metaDataSelectors";
import { DrillDownPage } from "../../../../store/types/drillDownPageState.types";
import AddCondition from "./AddCondition";
import { isMetricDrillDownInfo } from "./isMeasureDrillDownInfo";

interface Props {
  state: DrillDownState;
  configuration: DrillDownPage;
  info: MeasureDrillDownInfo | MetricDrillDownInfo;
}

export default function ConditionsPanel({ state, configuration, info }: Props) {
  const dimensions = useSelector(selectDimensions);

  const [detailedView, setDetailedView] = React.useState(true);

  const validDimensions = React.useMemo(() => {
    if (isMetricDrillDownInfo(info)) return dimensions;
    return info.allocated === true ? dimensions : dimensions.filter((d) => d.glAllowed === true);
  }, [info, dimensions]);

  if (!configuration || !info?.conditions || info.conditions.length === 0) {
    return <></>;
  }

  return (
    <PartContainer
      caption="Conditions"
      captionVariant="subtitle2"
      actions={
        <Stack direction={"row"} alignItems="center" gap={0.5}>
          <Typography>Detailed View</Typography>
          <Switch checked={detailedView} onChange={(_, value) => setDetailedView(value)}></Switch>
        </Stack>
      }
      sx={{ width: "340px", p: "1.3rem", pl: 3 }}
    >
      <Grid container sx={{ pt: 2, width: "100%" }}>
        <Conditions
          conditions={state.conditions}
          detailed={detailedView}
          canBeRemoved
          onRemoveFields={state.actions.removeCondition}
          onFieldChanged={state.actions.updateCondition}
          dimensions={validDimensions}
        />
      </Grid>
      <AddCondition
        text="Add Condition"
        conditions={state.conditions}
        dimensions={validDimensions}
        onAddField={state.actions.addCondition}
      />
    </PartContainer>
  );
}
